// Auto-generated sprite position index. [col, row] in a 8-column 64px grid.
export const SPRITE_INDEX: Record<string, Record<string, [number, number]>> = {
  'smileys': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
    '97': [0,12],
    '98': [1,12],
    '99': [2,12],
    '100': [3,12],
    '101': [4,12],
    '102': [5,12],
    '103': [6,12],
    '104': [7,12],
    '105': [0,13],
    '106': [1,13],
    '107': [2,13],
    '108': [3,13],
    '109': [4,13],
    '110': [5,13],
    '111': [6,13],
    '112': [7,13],
    '113': [0,14],
    '114': [1,14],
    '115': [2,14],
    '116': [3,14],
    '117': [4,14],
    '118': [5,14],
    '119': [6,14],
    '120': [7,14],
    '121': [0,15],
    '122': [1,15],
    '123': [2,15],
    '124': [3,15],
    '125': [4,15],
    '126': [5,15],
    '127': [6,15],
    '128': [7,15],
    '129': [0,16],
    '130': [1,16],
    '131': [2,16],
    '132': [3,16],
    '133': [4,16],
    '134': [5,16],
    '135': [6,16],
    '136': [7,16],
    '137': [0,17],
    '138': [1,17],
    '139': [2,17],
    '140': [3,17],
    '141': [4,17],
    '142': [5,17],
    '143': [6,17],
    '144': [7,17],
    '145': [0,18],
    '146': [1,18],
    '147': [2,18],
    '148': [3,18],
    '149': [4,18],
    '150': [5,18],
    '151': [6,18],
    '152': [7,18],
    '153': [0,19],
    '154': [1,19],
    '155': [2,19],
    '156': [3,19],
    '157': [4,19],
    '158': [5,19],
    '159': [6,19],
    '160': [7,19],
    '161': [0,20],
    '162': [1,20],
    '163': [2,20],
    '164': [3,20],
    '165': [4,20],
    '166': [5,20],
    '167': [6,20],
    '168': [7,20],
    '169': [0,21],
    '170': [1,21],
    '171': [2,21],
    '172': [3,21],
    '173': [4,21],
    '174': [5,21],
    '175': [6,21],
    '176': [7,21],
    '177': [0,22],
    '178': [1,22],
    '179': [2,22],
    '180': [3,22],
    '181': [4,22],
    '182': [5,22],
    '183': [6,22],
    '184': [7,22],
    '185': [0,23],
    '186': [1,23],
    '187': [2,23],
    '188': [3,23],
    '189': [4,23],
    '190': [5,23],
    '191': [6,23],
    '192': [7,23],
    '193': [0,24],
    '194': [1,24],
    '195': [2,24],
    '196': [3,24],
    '197': [4,24],
    '198': [5,24],
    '199': [6,24],
    '200': [7,24],
    '201': [0,25],
    '202': [1,25],
    '203': [2,25],
    '204': [3,25],
    '205': [4,25],
    '206': [5,25],
    '207': [6,25],
    '208': [7,25],
    '209': [0,26],
    '210': [1,26],
    '211': [2,26],
    '212': [3,26],
    '213': [4,26],
    '214': [5,26],
    '215': [6,26],
    '216': [7,26],
    '217': [0,27],
    '218': [1,27],
    '219': [2,27],
    '220': [3,27],
    '221': [4,27],
    '222': [5,27],
    '223': [6,27],
    '224': [7,27],
    '225': [0,28],
    '226': [1,28],
    '227': [2,28],
    '228': [3,28],
    '229': [4,28],
    '230': [5,28],
    '231': [6,28],
    '232': [7,28],
    '233': [0,29],
    '234': [1,29],
    '235': [2,29],
    '236': [3,29],
    '237': [4,29],
    '238': [5,29],
    '239': [6,29],
    '240': [7,29],
    '241': [0,30],
    '242': [1,30],
    '243': [2,30],
    '244': [3,30],
    '245': [4,30],
    '246': [5,30],
    '247': [6,30],
    '248': [7,30],
    '249': [0,31],
    '250': [1,31],
    '251': [2,31],
    '252': [3,31],
    '253': [4,31],
    '254': [5,31],
    '255': [6,31],
    '256': [7,31],
    '257': [0,32],
    '258': [1,32],
    '259': [2,32],
    '260': [3,32],
    '261': [4,32],
    '262': [5,32],
    '263': [6,32],
    '264': [7,32],
    '265': [0,33],
    '266': [1,33],
    '267': [2,33],
    '268': [3,33],
    '269': [4,33],
    '270': [5,33],
    '271': [6,33],
    '272': [7,33],
    '273': [0,34],
    '274': [1,34],
    '275': [2,34],
    '276': [3,34],
    '277': [4,34],
    '278': [5,34],
    '279': [6,34],
    '280': [7,34],
    '281': [0,35],
    '282': [1,35],
    '283': [2,35],
    '284': [3,35],
    '285': [4,35],
    '286': [5,35],
    '287': [6,35],
    '288': [7,35],
    '289': [0,36],
    '290': [1,36],
    '291': [2,36],
    '292': [3,36],
    '293': [4,36],
    '294': [5,36],
    '295': [6,36],
    '296': [7,36],
    '297': [0,37],
    '298': [1,37],
    '299': [2,37],
    '300': [3,37],
    '301': [4,37],
    '302': [5,37],
    '303': [6,37],
    '304': [7,37],
    '305': [0,38],
    '306': [1,38],
    '307': [2,38],
    '308': [3,38],
    '309': [4,38],
    '310': [5,38],
    '311': [6,38],
    '312': [7,38],
    '313': [0,39],
    '314': [1,39],
    '315': [2,39],
    '316': [3,39],
    '317': [4,39],
    '318': [5,39],
    '319': [6,39],
    '320': [7,39],
    '321': [0,40],
    '322': [1,40],
    '323': [2,40],
    '324': [3,40],
    '325': [4,40],
    '326': [5,40],
    '327': [6,40],
    '328': [7,40],
    '329': [0,41],
    '330': [1,41],
    '331': [2,41],
    '332': [3,41],
    '333': [4,41],
    '334': [5,41],
    '335': [6,41],
    '336': [7,41],
    '337': [0,42],
    '338': [1,42],
    '339': [2,42],
    '340': [3,42],
    '341': [4,42],
    '342': [5,42],
    '343': [6,42],
    '344': [7,42],
    '345': [0,43],
    '346': [1,43],
    '347': [2,43],
    '348': [3,43],
    '349': [4,43],
    '350': [5,43],
    '351': [6,43],
    '352': [7,43],
    '353': [0,44],
    '354': [1,44],
    '355': [2,44],
    '356': [3,44],
    '357': [4,44],
    '358': [5,44],
    '359': [6,44],
    '360': [7,44],
    '361': [0,45],
    '362': [1,45],
    '363': [2,45],
    '364': [3,45],
    '365': [4,45],
    '366': [5,45],
    '367': [6,45],
    '368': [7,45],
    '369': [0,46],
    '370': [1,46],
    '371': [2,46],
    '372': [3,46],
    '373': [4,46],
    '374': [5,46],
    '375': [6,46],
    '376': [7,46],
    '377': [0,47],
    '378': [1,47],
    '379': [2,47],
    '380': [3,47],
    '381': [4,47],
    '382': [5,47],
    '383': [6,47],
    '384': [7,47],
    '385': [0,48],
    '386': [1,48],
    '387': [2,48],
    '388': [3,48],
    '389': [4,48],
    '390': [5,48],
    '391': [6,48],
    '392': [7,48],
    '393': [0,49],
    '394': [1,49],
    '395': [2,49],
    '396': [3,49],
    '397': [4,49],
    '398': [5,49],
    '399': [6,49],
    '400': [7,49],
    '401': [0,50],
    '402': [1,50],
    '403': [2,50],
    '404': [3,50],
    '405': [4,50],
    '406': [5,50],
    '407': [6,50],
    '408': [7,50],
    '409': [0,51],
    '410': [1,51],
    '411': [2,51],
    '412': [3,51],
    '413': [4,51],
    '414': [5,51],
    '415': [6,51],
    '416': [7,51],
    '417': [0,52],
    '418': [1,52],
    '419': [2,52],
    '420': [3,52],
    '421': [4,52],
    '422': [5,52],
    '423': [6,52],
    '424': [7,52],
    '425': [0,53],
    '426': [1,53],
    '427': [2,53],
    '428': [3,53],
    '429': [4,53],
    '430': [5,53],
    '431': [6,53],
    '432': [7,53],
  },
  'symbols': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
    '97': [0,12],
    '98': [1,12],
    '99': [2,12],
    '100': [3,12],
    '101': [4,12],
    '102': [5,12],
    '103': [6,12],
    '104': [7,12],
    '105': [0,13],
    '106': [1,13],
    '107': [2,13],
    '108': [3,13],
    '109': [4,13],
    '110': [5,13],
    '111': [6,13],
    '112': [7,13],
    '113': [0,14],
    '114': [1,14],
    '115': [2,14],
    '116': [3,14],
    '117': [4,14],
    '118': [5,14],
    '119': [6,14],
    '120': [7,14],
    '121': [0,15],
    '122': [1,15],
    '123': [2,15],
    '124': [3,15],
    '125': [4,15],
    '126': [5,15],
    '127': [6,15],
    '128': [7,15],
    '129': [0,16],
    '130': [1,16],
    '131': [2,16],
    '132': [3,16],
    '133': [4,16],
    '134': [5,16],
    '135': [6,16],
    '136': [7,16],
    '137': [0,17],
    '138': [1,17],
    '139': [2,17],
    '140': [3,17],
    '141': [4,17],
    '142': [5,17],
    '143': [6,17],
    '144': [7,17],
    '145': [0,18],
    '146': [1,18],
    '147': [2,18],
    '148': [3,18],
    '149': [4,18],
    '150': [5,18],
    '151': [6,18],
    '152': [7,18],
    '153': [0,19],
    '154': [1,19],
    '155': [2,19],
    '156': [3,19],
    '157': [4,19],
    '158': [5,19],
    '159': [6,19],
    '160': [7,19],
    '161': [0,20],
    '162': [1,20],
    '163': [2,20],
    '164': [3,20],
    '165': [4,20],
    '166': [5,20],
    '167': [6,20],
    '168': [7,20],
    '169': [0,21],
    '170': [1,21],
    '171': [2,21],
    '172': [3,21],
    '173': [4,21],
    '174': [5,21],
    '175': [6,21],
    '176': [7,21],
    '177': [0,22],
    '178': [1,22],
    '179': [2,22],
    '180': [3,22],
    '181': [4,22],
    '182': [5,22],
    '183': [6,22],
    '184': [7,22],
    '185': [0,23],
    '186': [1,23],
    '187': [2,23],
    '188': [3,23],
    '189': [4,23],
    '190': [5,23],
    '191': [6,23],
    '192': [7,23],
    '193': [0,24],
    '194': [1,24],
    '195': [2,24],
    '196': [3,24],
    '197': [4,24],
    '198': [5,24],
    '199': [6,24],
    '200': [7,24],
    '201': [0,25],
    '202': [1,25],
    '203': [2,25],
    '204': [3,25],
    '205': [4,25],
    '206': [5,25],
    '207': [6,25],
    '208': [7,25],
    '209': [0,26],
    '210': [1,26],
    '211': [2,26],
    '212': [3,26],
    '213': [4,26],
    '214': [5,26],
    '215': [6,26],
    '216': [7,26],
    '217': [0,27],
    '218': [1,27],
    '219': [2,27],
    '220': [3,27],
    '221': [4,27],
    '222': [5,27],
    '223': [6,27],
    '224': [7,27],
    '225': [0,28],
    '226': [1,28],
    '227': [2,28],
    '228': [3,28],
    '229': [4,28],
    '230': [5,28],
    '231': [6,28],
    '232': [7,28],
    '233': [0,29],
    '234': [1,29],
    '235': [2,29],
    '236': [3,29],
    '237': [4,29],
    '238': [5,29],
    '239': [6,29],
    '240': [7,29],
    '241': [0,30],
    '242': [1,30],
    '243': [2,30],
    '244': [3,30],
    '245': [4,30],
    '246': [5,30],
    '247': [6,30],
    '248': [7,30],
    '249': [0,31],
    '250': [1,31],
    '251': [2,31],
    '252': [3,31],
    '253': [4,31],
    '254': [5,31],
    '255': [6,31],
    '256': [7,31],
    '257': [0,32],
    '258': [1,32],
    '259': [2,32],
    '260': [3,32],
    '261': [4,32],
    '262': [5,32],
    '263': [6,32],
    '264': [7,32],
    '265': [0,33],
    '266': [1,33],
    '267': [2,33],
    '268': [3,33],
    '269': [4,33],
    '270': [5,33],
    '271': [6,33],
    '272': [7,33],
    '273': [0,34],
    '274': [1,34],
    '275': [2,34],
    '276': [3,34],
    '277': [4,34],
    '278': [5,34],
    '279': [6,34],
    '280': [7,34],
    '281': [0,35],
    '282': [1,35],
    '283': [2,35],
    '284': [3,35],
    '285': [4,35],
    '286': [5,35],
    '287': [6,35],
    '288': [7,35],
    '289': [0,36],
    '290': [1,36],
    '291': [2,36],
    '292': [3,36],
    '293': [4,36],
    '294': [5,36],
    '295': [6,36],
    '296': [7,36],
    '297': [0,37],
    '298': [1,37],
    '299': [2,37],
    '300': [3,37],
    '301': [4,37],
    '302': [5,37],
    '303': [6,37],
    '304': [7,37],
    '305': [0,38],
    '306': [1,38],
    '307': [2,38],
    '308': [3,38],
    '309': [4,38],
    '310': [5,38],
    '311': [6,38],
    '312': [7,38],
    '313': [0,39],
    '314': [1,39],
    '315': [2,39],
    '316': [3,39],
    '317': [4,39],
    '318': [5,39],
    '319': [6,39],
    '320': [7,39],
    '321': [0,40],
    '322': [1,40],
    '323': [2,40],
    '324': [3,40],
    '325': [4,40],
    '326': [5,40],
    '327': [6,40],
    '328': [7,40],
    '329': [0,41],
    '330': [1,41],
    '331': [2,41],
    '332': [3,41],
    '333': [4,41],
    '334': [5,41],
    '335': [6,41],
    '336': [7,41],
  },
  'nature': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
    '97': [0,12],
    '98': [1,12],
    '99': [2,12],
    '100': [3,12],
    '101': [4,12],
    '102': [5,12],
    '103': [6,12],
    '104': [7,12],
    '105': [0,13],
    '106': [1,13],
    '107': [2,13],
    '108': [3,13],
    '109': [4,13],
    '110': [5,13],
    '111': [6,13],
    '112': [7,13],
    '113': [0,14],
    '114': [1,14],
    '115': [2,14],
    '116': [3,14],
    '117': [4,14],
    '118': [5,14],
    '119': [6,14],
    '120': [7,14],
    '121': [0,15],
    '122': [1,15],
    '123': [2,15],
    '124': [3,15],
    '125': [4,15],
    '126': [5,15],
    '127': [6,15],
    '128': [7,15],
    '129': [0,16],
    '130': [1,16],
    '131': [2,16],
    '132': [3,16],
    '133': [4,16],
    '134': [5,16],
    '135': [6,16],
    '136': [7,16],
    '137': [0,17],
    '138': [1,17],
    '139': [2,17],
    '140': [3,17],
    '141': [4,17],
    '142': [5,17],
    '143': [6,17],
    '144': [7,17],
    '145': [0,18],
    '146': [1,18],
    '147': [2,18],
    '148': [3,18],
    '149': [4,18],
    '150': [5,18],
    '151': [6,18],
    '152': [7,18],
    '153': [0,19],
    '154': [1,19],
    '155': [2,19],
    '156': [3,19],
    '157': [4,19],
    '158': [5,19],
    '159': [6,19],
    '160': [7,19],
    '161': [0,20],
    '162': [1,20],
    '163': [2,20],
    '164': [3,20],
    '165': [4,20],
    '166': [5,20],
    '167': [6,20],
    '168': [7,20],
  },
  'food-and-drinks': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
    '97': [0,12],
    '98': [1,12],
    '99': [2,12],
    '100': [3,12],
    '101': [4,12],
    '102': [5,12],
    '103': [6,12],
    '104': [7,12],
    '105': [0,13],
    '106': [1,13],
    '107': [2,13],
    '108': [3,13],
    '109': [4,13],
    '110': [5,13],
    '111': [6,13],
    '112': [7,13],
    '113': [0,14],
    '114': [1,14],
    '115': [2,14],
    '116': [3,14],
    '117': [4,14],
    '118': [5,14],
    '119': [6,14],
    '120': [7,14],
    '121': [0,15],
    '122': [1,15],
    '123': [2,15],
    '124': [3,15],
    '125': [4,15],
    '126': [5,15],
    '127': [6,15],
    '128': [7,15],
    '129': [0,16],
    '130': [1,16],
    '131': [2,16],
    '132': [3,16],
    '133': [4,16],
    '134': [5,16],
    '135': [6,16],
    '136': [7,16],
    '137': [0,17],
    '138': [1,17],
    '139': [2,17],
    '140': [3,17],
    '141': [4,17],
    '142': [5,17],
    '143': [6,17],
    '144': [7,17],
    '145': [0,18],
    '146': [1,18],
    '147': [2,18],
    '148': [3,18],
    '149': [4,18],
    '150': [5,18],
    '151': [6,18],
    '152': [7,18],
    '153': [0,19],
    '154': [1,19],
    '155': [2,19],
    '156': [3,19],
    '157': [4,19],
    '158': [5,19],
    '159': [6,19],
    '160': [7,19],
    '161': [0,20],
    '162': [1,20],
    '163': [2,20],
    '164': [3,20],
    '165': [4,20],
    '166': [5,20],
    '167': [6,20],
    '168': [7,20],
    '169': [0,21],
    '170': [1,21],
    '171': [2,21],
    '172': [3,21],
    '173': [4,21],
    '174': [5,21],
    '175': [6,21],
    '176': [7,21],
    '177': [0,22],
    '178': [1,22],
    '179': [2,22],
    '180': [3,22],
    '181': [4,22],
    '182': [5,22],
    '183': [6,22],
    '184': [7,22],
    '185': [0,23],
    '186': [1,23],
    '187': [2,23],
    '188': [3,23],
    '189': [4,23],
    '190': [5,23],
    '191': [6,23],
    '192': [7,23],
    '193': [0,24],
    '194': [1,24],
    '195': [2,24],
    '196': [3,24],
    '197': [4,24],
    '198': [5,24],
    '199': [6,24],
    '200': [7,24],
    '201': [0,25],
    '202': [1,25],
    '203': [2,25],
    '204': [3,25],
    '205': [4,25],
    '206': [5,25],
    '207': [6,25],
    '208': [7,25],
    '209': [0,26],
    '210': [1,26],
    '211': [2,26],
    '212': [3,26],
    '213': [4,26],
    '214': [5,26],
    '215': [6,26],
    '216': [7,26],
    '217': [0,27],
    '218': [1,27],
    '219': [2,27],
    '220': [3,27],
    '221': [4,27],
    '222': [5,27],
    '223': [6,27],
    '224': [7,27],
    '225': [0,28],
    '226': [1,28],
    '227': [2,28],
    '228': [3,28],
    '229': [4,28],
    '230': [5,28],
    '231': [6,28],
    '232': [7,28],
    '233': [0,29],
    '234': [1,29],
    '235': [2,29],
    '236': [3,29],
    '237': [4,29],
    '238': [5,29],
    '239': [6,29],
    '240': [7,29],
    '241': [0,30],
    '242': [1,30],
    '243': [2,30],
    '244': [3,30],
    '245': [4,30],
    '246': [5,30],
    '247': [6,30],
    '248': [7,30],
    '249': [0,31],
    '250': [1,31],
    '251': [2,31],
    '252': [3,31],
    '253': [4,31],
    '254': [5,31],
    '255': [6,31],
    '256': [7,31],
    '257': [0,32],
    '258': [1,32],
    '259': [2,32],
    '260': [3,32],
    '261': [4,32],
    '262': [5,32],
    '263': [6,32],
    '264': [7,32],
    '265': [0,33],
    '266': [1,33],
    '267': [2,33],
    '268': [3,33],
    '269': [4,33],
    '270': [5,33],
    '271': [6,33],
    '272': [7,33],
    '273': [0,34],
    '274': [1,34],
    '275': [2,34],
    '276': [3,34],
    '277': [4,34],
    '278': [5,34],
    '279': [6,34],
    '280': [7,34],
    '281': [0,35],
    '282': [1,35],
    '283': [2,35],
    '284': [3,35],
    '285': [4,35],
    '286': [5,35],
    '287': [6,35],
    '288': [7,35],
    '289': [0,36],
    '290': [1,36],
    '291': [2,36],
    '292': [3,36],
    '293': [4,36],
    '294': [5,36],
    '295': [6,36],
    '296': [7,36],
    '297': [0,37],
    '298': [1,37],
    '299': [2,37],
    '300': [3,37],
    '301': [4,37],
    '302': [5,37],
    '303': [6,37],
    '304': [7,37],
    '305': [0,38],
    '306': [1,38],
    '307': [2,38],
    '308': [3,38],
    '309': [4,38],
    '310': [5,38],
    '311': [6,38],
    '312': [7,38],
    '313': [0,39],
    '314': [1,39],
    '315': [2,39],
    '316': [3,39],
    '317': [4,39],
    '318': [5,39],
    '319': [6,39],
    '320': [7,39],
    '321': [0,40],
    '322': [1,40],
    '323': [2,40],
    '324': [3,40],
    '325': [4,40],
    '326': [5,40],
    '327': [6,40],
    '328': [7,40],
    '329': [0,41],
    '330': [1,41],
    '331': [2,41],
    '332': [3,41],
    '333': [4,41],
    '334': [5,41],
    '335': [6,41],
    '336': [7,41],
    '337': [0,42],
    '338': [1,42],
    '339': [2,42],
    '340': [3,42],
    '341': [4,42],
    '342': [5,42],
    '343': [6,42],
    '344': [7,42],
    '345': [0,43],
    '346': [1,43],
    '347': [2,43],
    '348': [3,43],
    '349': [4,43],
    '350': [5,43],
    '351': [6,43],
    '352': [7,43],
    '353': [0,44],
    '354': [1,44],
    '355': [2,44],
    '356': [3,44],
    '357': [4,44],
    '358': [5,44],
    '359': [6,44],
    '360': [7,44],
    '361': [0,45],
    '362': [1,45],
    '363': [2,45],
    '364': [3,45],
    '365': [4,45],
    '366': [5,45],
    '367': [6,45],
    '368': [7,45],
    '369': [0,46],
    '370': [1,46],
    '371': [2,46],
    '372': [3,46],
    '373': [4,46],
    '374': [5,46],
    '375': [6,46],
    '376': [7,46],
    '377': [0,47],
    '378': [1,47],
    '379': [2,47],
    '380': [3,47],
    '381': [4,47],
    '382': [5,47],
    '383': [6,47],
    '384': [7,47],
    '385': [0,48],
    '386': [1,48],
    '387': [2,48],
    '388': [3,48],
    '389': [4,48],
    '390': [5,48],
    '391': [6,48],
    '392': [7,48],
    '393': [0,49],
    '394': [1,49],
    '395': [2,49],
    '396': [3,49],
    '397': [4,49],
    '398': [5,49],
    '399': [6,49],
    '400': [7,49],
    '401': [0,50],
    '402': [1,50],
    '403': [2,50],
    '404': [3,50],
    '405': [4,50],
    '406': [5,50],
    '407': [6,50],
    '408': [7,50],
  },
  'travel-and-places': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
    '97': [0,12],
    '98': [1,12],
    '99': [2,12],
    '100': [3,12],
    '101': [4,12],
    '102': [5,12],
    '103': [6,12],
    '104': [7,12],
    '105': [0,13],
    '106': [1,13],
    '107': [2,13],
    '108': [3,13],
    '109': [4,13],
    '110': [5,13],
    '111': [6,13],
    '112': [7,13],
    '113': [0,14],
    '114': [1,14],
    '115': [2,14],
    '116': [3,14],
    '117': [4,14],
    '118': [5,14],
    '119': [6,14],
    '120': [7,14],
    '121': [0,15],
    '122': [1,15],
    '123': [2,15],
    '124': [3,15],
    '125': [4,15],
    '126': [5,15],
    '127': [6,15],
    '128': [7,15],
    '129': [0,16],
    '130': [1,16],
    '131': [2,16],
    '132': [3,16],
    '133': [4,16],
    '134': [5,16],
    '135': [6,16],
    '136': [7,16],
    '137': [0,17],
    '138': [1,17],
    '139': [2,17],
    '140': [3,17],
    '141': [4,17],
    '142': [5,17],
    '143': [6,17],
    '144': [7,17],
    '145': [0,18],
    '146': [1,18],
    '147': [2,18],
    '148': [3,18],
    '149': [4,18],
    '150': [5,18],
    '151': [6,18],
    '152': [7,18],
    '153': [0,19],
    '154': [1,19],
    '155': [2,19],
    '156': [3,19],
    '157': [4,19],
    '158': [5,19],
    '159': [6,19],
    '160': [7,19],
    '161': [0,20],
    '162': [1,20],
    '163': [2,20],
    '164': [3,20],
    '165': [4,20],
    '166': [5,20],
    '167': [6,20],
    '168': [7,20],
    '169': [0,21],
    '170': [1,21],
    '171': [2,21],
    '172': [3,21],
    '173': [4,21],
    '174': [5,21],
    '175': [6,21],
    '176': [7,21],
    '177': [0,22],
    '178': [1,22],
    '179': [2,22],
    '180': [3,22],
    '181': [4,22],
    '182': [5,22],
    '183': [6,22],
    '184': [7,22],
    '185': [0,23],
    '186': [1,23],
    '187': [2,23],
    '188': [3,23],
    '189': [4,23],
    '190': [5,23],
    '191': [6,23],
    '192': [7,23],
    '193': [0,24],
    '194': [1,24],
    '195': [2,24],
    '196': [3,24],
    '197': [4,24],
    '198': [5,24],
    '199': [6,24],
    '200': [7,24],
    '201': [0,25],
    '202': [1,25],
    '203': [2,25],
    '204': [3,25],
    '205': [4,25],
    '206': [5,25],
    '207': [6,25],
    '208': [7,25],
    '209': [0,26],
    '210': [1,26],
    '211': [2,26],
    '212': [3,26],
  },
  'animals': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
    '97': [0,12],
    '98': [1,12],
    '99': [2,12],
    '100': [3,12],
    '101': [4,12],
    '102': [5,12],
    '103': [6,12],
    '104': [7,12],
    '105': [0,13],
    '106': [1,13],
    '107': [2,13],
    '108': [3,13],
    '109': [4,13],
    '110': [5,13],
    '111': [6,13],
    '112': [7,13],
    '113': [0,14],
    '114': [1,14],
    '115': [2,14],
    '116': [3,14],
    '117': [4,14],
    '118': [5,14],
    '119': [6,14],
    '120': [7,14],
    '121': [0,15],
    '122': [1,15],
    '123': [2,15],
    '124': [3,15],
    '125': [4,15],
    '126': [5,15],
    '127': [6,15],
    '128': [7,15],
    '129': [0,16],
    '130': [1,16],
    '131': [2,16],
    '132': [3,16],
    '133': [4,16],
    '134': [5,16],
    '135': [6,16],
    '136': [7,16],
    '137': [0,17],
    '138': [1,17],
    '139': [2,17],
    '140': [3,17],
    '141': [4,17],
    '142': [5,17],
    '143': [6,17],
    '144': [7,17],
    '145': [0,18],
    '146': [1,18],
    '147': [2,18],
    '148': [3,18],
    '149': [4,18],
    '150': [5,18],
    '151': [6,18],
    '152': [7,18],
    '153': [0,19],
    '154': [1,19],
    '155': [2,19],
    '156': [3,19],
    '157': [4,19],
    '158': [5,19],
    '159': [6,19],
    '160': [7,19],
    '161': [0,20],
    '162': [1,20],
    '163': [2,20],
    '164': [3,20],
    '165': [4,20],
    '166': [5,20],
    '167': [6,20],
    '168': [7,20],
    '169': [0,21],
    '170': [1,21],
    '171': [2,21],
    '172': [3,21],
    '173': [4,21],
    '174': [5,21],
    '175': [6,21],
    '176': [7,21],
    '177': [0,22],
    '178': [1,22],
    '179': [2,22],
    '180': [3,22],
    '181': [4,22],
    '182': [5,22],
    '183': [6,22],
    '184': [7,22],
    '185': [0,23],
    '186': [1,23],
    '187': [2,23],
    '188': [3,23],
    '189': [4,23],
    '190': [5,23],
    '191': [6,23],
    '192': [7,23],
    '193': [0,24],
    '194': [1,24],
    '195': [2,24],
    '196': [3,24],
    '197': [4,24],
    '198': [5,24],
    '199': [6,24],
    '200': [7,24],
    '201': [0,25],
    '202': [1,25],
    '203': [2,25],
    '204': [3,25],
    '205': [4,25],
    '206': [5,25],
    '207': [6,25],
    '208': [7,25],
    '209': [0,26],
  },
  'gestures': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
  },
  'objects': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
    '97': [0,12],
    '98': [1,12],
    '99': [2,12],
    '100': [3,12],
    '101': [4,12],
    '102': [5,12],
    '103': [6,12],
    '104': [7,12],
    '105': [0,13],
    '106': [1,13],
    '107': [2,13],
    '108': [3,13],
    '109': [4,13],
    '110': [5,13],
    '111': [6,13],
    '112': [7,13],
    '113': [0,14],
    '114': [1,14],
    '115': [2,14],
    '116': [3,14],
    '117': [4,14],
    '118': [5,14],
    '119': [6,14],
    '120': [7,14],
    '121': [0,15],
    '122': [1,15],
    '123': [2,15],
    '124': [3,15],
    '125': [4,15],
    '126': [5,15],
    '127': [6,15],
    '128': [7,15],
    '129': [0,16],
    '130': [1,16],
    '131': [2,16],
    '132': [3,16],
    '133': [4,16],
    '134': [5,16],
    '135': [6,16],
    '136': [7,16],
    '137': [0,17],
    '138': [1,17],
    '139': [2,17],
    '140': [3,17],
    '141': [4,17],
    '142': [5,17],
    '143': [6,17],
    '144': [7,17],
    '145': [0,18],
    '146': [1,18],
    '147': [2,18],
    '148': [3,18],
    '149': [4,18],
    '150': [5,18],
    '151': [6,18],
    '152': [7,18],
    '153': [0,19],
    '154': [1,19],
    '155': [2,19],
    '156': [3,19],
    '157': [4,19],
    '158': [5,19],
    '159': [6,19],
    '160': [7,19],
    '161': [0,20],
    '162': [1,20],
    '163': [2,20],
    '164': [3,20],
    '165': [4,20],
    '166': [5,20],
    '167': [6,20],
    '168': [7,20],
    '169': [0,21],
    '170': [1,21],
    '171': [2,21],
    '172': [3,21],
    '173': [4,21],
    '174': [5,21],
    '175': [6,21],
    '176': [7,21],
    '177': [0,22],
    '178': [1,22],
    '179': [2,22],
    '180': [3,22],
    '181': [4,22],
    '182': [5,22],
    '183': [6,22],
    '184': [7,22],
    '185': [0,23],
    '186': [1,23],
    '187': [2,23],
    '188': [3,23],
    '189': [4,23],
    '190': [5,23],
    '191': [6,23],
    '192': [7,23],
  },
  'activity': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
    '97': [0,12],
    '98': [1,12],
    '99': [2,12],
    '100': [3,12],
    '101': [4,12],
    '102': [5,12],
    '103': [6,12],
    '104': [7,12],
    '105': [0,13],
    '106': [1,13],
    '107': [2,13],
    '108': [3,13],
    '109': [4,13],
    '110': [5,13],
    '111': [6,13],
    '112': [7,13],
    '113': [0,14],
    '114': [1,14],
    '115': [2,14],
    '116': [3,14],
    '117': [4,14],
    '118': [5,14],
    '119': [6,14],
    '120': [7,14],
    '121': [0,15],
    '122': [1,15],
    '123': [2,15],
    '124': [3,15],
    '125': [4,15],
    '126': [5,15],
    '127': [6,15],
    '128': [7,15],
    '129': [0,16],
    '130': [1,16],
    '131': [2,16],
    '132': [3,16],
    '133': [4,16],
    '134': [5,16],
    '135': [6,16],
    '136': [7,16],
    '137': [0,17],
    '138': [1,17],
    '139': [2,17],
    '140': [3,17],
    '141': [4,17],
    '142': [5,17],
    '143': [6,17],
    '144': [7,17],
    '145': [0,18],
    '146': [1,18],
    '147': [2,18],
    '148': [3,18],
    '149': [4,18],
    '150': [5,18],
    '151': [6,18],
    '152': [7,18],
    '153': [0,19],
    '154': [1,19],
    '155': [2,19],
    '156': [3,19],
    '157': [4,19],
    '158': [5,19],
    '159': [6,19],
    '160': [7,19],
    '161': [0,20],
    '162': [1,20],
    '163': [2,20],
    '164': [3,20],
    '165': [4,20],
    '166': [5,20],
    '167': [6,20],
    '168': [7,20],
    '169': [0,21],
    '170': [1,21],
    '171': [2,21],
    '172': [3,21],
    '173': [4,21],
    '174': [5,21],
    '175': [6,21],
    '176': [7,21],
    '177': [0,22],
    '178': [1,22],
    '179': [2,22],
    '180': [3,22],
    '181': [4,22],
    '182': [5,22],
    '183': [6,22],
    '184': [7,22],
    '185': [0,23],
  },
  'people': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
    '97': [0,12],
    '98': [1,12],
    '99': [2,12],
    '100': [3,12],
    '101': [4,12],
    '102': [5,12],
    '103': [6,12],
    '104': [7,12],
    '105': [0,13],
    '106': [1,13],
    '107': [2,13],
    '108': [3,13],
    '109': [4,13],
    '110': [5,13],
    '111': [6,13],
    '112': [7,13],
    '113': [0,14],
    '114': [1,14],
    '115': [2,14],
    '116': [3,14],
    '117': [4,14],
    '118': [5,14],
    '119': [6,14],
    '120': [7,14],
    '121': [0,15],
    '122': [1,15],
    '123': [2,15],
    '124': [3,15],
    '125': [4,15],
    '126': [5,15],
    '127': [6,15],
    '128': [7,15],
    '129': [0,16],
    '130': [1,16],
    '131': [2,16],
    '132': [3,16],
    '133': [4,16],
    '134': [5,16],
    '135': [6,16],
    '136': [7,16],
    '137': [0,17],
    '138': [1,17],
    '139': [2,17],
    '140': [3,17],
    '141': [4,17],
    '142': [5,17],
    '143': [6,17],
    '144': [7,17],
    '145': [0,18],
    '146': [1,18],
    '147': [2,18],
    '148': [3,18],
    '149': [4,18],
    '150': [5,18],
    '151': [6,18],
    '152': [7,18],
    '153': [0,19],
    '154': [1,19],
    '155': [2,19],
    '156': [3,19],
    '157': [4,19],
    '158': [5,19],
    '159': [6,19],
    '160': [7,19],
    '161': [0,20],
    '162': [1,20],
    '163': [2,20],
    '164': [3,20],
    '165': [4,20],
    '166': [5,20],
    '167': [6,20],
    '168': [7,20],
    '169': [0,21],
    '170': [1,21],
    '171': [2,21],
    '172': [3,21],
    '173': [4,21],
  },
  'buildings': {
    '1': [0,0],
    '2': [1,0],
    '3': [2,0],
    '4': [3,0],
    '5': [4,0],
    '6': [5,0],
    '7': [6,0],
    '8': [7,0],
    '9': [0,1],
    '10': [1,1],
    '11': [2,1],
    '12': [3,1],
    '13': [4,1],
    '14': [5,1],
    '15': [6,1],
    '16': [7,1],
    '17': [0,2],
    '18': [1,2],
    '19': [2,2],
    '20': [3,2],
    '21': [4,2],
    '22': [5,2],
    '23': [6,2],
    '24': [7,2],
    '25': [0,3],
    '26': [1,3],
    '27': [2,3],
    '28': [3,3],
    '29': [4,3],
    '30': [5,3],
    '31': [6,3],
    '32': [7,3],
    '33': [0,4],
    '34': [1,4],
    '35': [2,4],
    '36': [3,4],
    '37': [4,4],
    '38': [5,4],
    '39': [6,4],
    '40': [7,4],
    '41': [0,5],
    '42': [1,5],
    '43': [2,5],
    '44': [3,5],
    '45': [4,5],
    '46': [5,5],
    '47': [6,5],
    '48': [7,5],
    '49': [0,6],
    '50': [1,6],
    '51': [2,6],
    '52': [3,6],
    '53': [4,6],
    '54': [5,6],
    '55': [6,6],
    '56': [7,6],
    '57': [0,7],
    '58': [1,7],
    '59': [2,7],
    '60': [3,7],
    '61': [4,7],
    '62': [5,7],
    '63': [6,7],
    '64': [7,7],
    '65': [0,8],
    '66': [1,8],
    '67': [2,8],
    '68': [3,8],
    '69': [4,8],
    '70': [5,8],
    '71': [6,8],
    '72': [7,8],
    '73': [0,9],
    '74': [1,9],
    '75': [2,9],
    '76': [3,9],
    '77': [4,9],
    '78': [5,9],
    '79': [6,9],
    '80': [7,9],
    '81': [0,10],
    '82': [1,10],
    '83': [2,10],
    '84': [3,10],
    '85': [4,10],
    '86': [5,10],
    '87': [6,10],
    '88': [7,10],
    '89': [0,11],
    '90': [1,11],
    '91': [2,11],
    '92': [3,11],
    '93': [4,11],
    '94': [5,11],
    '95': [6,11],
    '96': [7,11],
    '97': [0,12],
    '98': [1,12],
    '99': [2,12],
    '100': [3,12],
  },
};
export const SPRITE_CELL = 64;